import { motion, useTransform } from "framer-motion";

import { useBreakpoints } from "@/hooks/use-breakpoints";

import { AuthButton } from "@/components/buttons/auth";
import { Container } from "@/components/container";
import { Heading } from "@/components/heading";
import { PageHeader } from "@/components/page-header";

import css from "./first-section.module.scss";

const FirstSection = ({
  firstSectionRef,
  firstSectionScrollProgressY,
  firstSectionDimensions,
  onStartClick,
}) => {
  const bps = useBreakpoints();

  const onClick = () => {
    // ? here open new window
  };

  const contentOpacity = useTransform(
    firstSectionScrollProgressY,
    [0, 0.5],
    [1, 0]
  );
  const contentY = useTransform(
    firstSectionScrollProgressY,
    [0, 0.5],
    [0, firstSectionDimensions.height / 4]
  );

  return (
    <header ref={firstSectionRef} className={css.section}>
      <Container className={css.sectionContainer}>
        <motion.div
          style={{
            opacity: bps.desktop && contentOpacity,
            translateY: bps.desktop && contentY,
            transform: "translateZ(0px)",
          }}
          className={css.firstSectionMotionDiv}
        >
          <div className={css.firstSectionMotionDiv}>
            {bps.mobile && !bps.tablet && <PageHeader />}
            <div>
              <Heading className={css.mainHeading} type="main">
                Простая CRM для продаж в мессенджерах
              </Heading>
              {bps.isComputed && (
                <div className={css.main_controls}>
                  {bps.tablet && !bps.desktop && (
                    <AuthButton
                      className={css.start_button}
                      onClick={onClick}
                    />
                  )}
                  {bps.mobile && !bps.tablet && (
                    <AuthButton noModal onClick={onStartClick} className={css.start_button} />
                  )}
                </div>
              )}
            </div>
          </div>
        </motion.div>
      </Container>
    </header>
  );
};

export default FirstSection;
